module.exports = __webpack_public_path__ + "20250721160708/img/wechat.538b5d5f.png";